import { render } from "./App.vue?vue&type=template&id=51668280"
const script = {}

import "./App.vue?vue&type=style&index=0&id=51668280&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_cb1520cd3869e9bb53954e6d33967bbc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__